import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIntent} from '@mintdata-wsp/common/components/MDIntent';
import {IStyles, Styles} from '@mintdata/mint-kit/impl/util/Styles';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const buttonStyles = require('@mintdata-wsp/common/components/button/Button.less');

export enum ButtonStyle
{
    Raised = 'raisedStyle',
    Simple = 'simpleStyle',
    Neutral = 'neutralStyle',
    SimpleSecondary = 'simpleSecondaryStyle'
}

export enum ButtonSize
{
    ExtraSmall = 'extraSmallSize',
    Small = 'smallSize',
    BelowMedium = 'belowMediumSize',
    Medium = 'mediumSize',
    Default = 'defaultSize',
    Large = 'largeSize',
    ExtraLarge = 'extraLargeSize'
}

export type ButtonMouseHandler = (event:React.MouseEvent<HTMLButtonElement>) => void;

export interface IButtonProps
{
    id?:string;
    caption?:string;
    icon?:string | React.ReactElement<any>;
    iconSize?:MDIconSize;
    theme?:IStyles;
    onClick?:ButtonMouseHandler;
    onMouseDown?:ButtonMouseHandler;
    onMouseUp?:ButtonMouseHandler;
    onDblClick?:ButtonMouseHandler;
    className?:string;
    iconClassName?:string;
    captionClassName?:string;
    style?:ButtonStyle;
    size?:ButtonSize;
    intent?:MDIntent;
    isDisabled?:boolean;
    relativeIcon?:boolean
}

export interface IButtonState
{
    styles:IStyles;
}

export class Button extends React.Component<IButtonProps, IButtonState>
{
    public constructor(props:any)
    {
        super(props);

        this.state = {
            styles: null,
        };
    }

    @bind
    private _onClick(event:React.MouseEvent<HTMLButtonElement>):void
    {
        const {onClick} = this.props;

        if( onClick )
            onClick(event);
    }

    @bind
    private _onMouseDown(event:React.MouseEvent<HTMLButtonElement>):void
    {
        const {onMouseDown} = this.props;

        if( onMouseDown )
            onMouseDown(event);
    }

    @bind
    private _onMouseUp(event:React.MouseEvent<HTMLButtonElement>):void
    {
        const {onMouseUp} = this.props;

        if( onMouseUp )
            onMouseUp(event);
    }

    @bind
    private _onDblClick(event:React.MouseEvent<HTMLButtonElement>):void
    {
        const {onDblClick} = this.props;

        if( onDblClick )
            onDblClick(event);
    }

    private _initStyles(styles:IStyles):void
    {
        this.setState({
            styles: Styles.unionStyles(styles, buttonStyles)
        });
    }

    public componentWillMount():void
    {
        const {theme} = this.props;
        this._initStyles(theme);
    }

    public componentWillReceiveProps(newProps:IButtonProps):void
    {
        const {theme} = this.props;
        this._initStyles(theme);
    }

    public render():JSX.Element
    {
        const {
            id,
            className,
            iconClassName,
            captionClassName,
            icon,
            iconSize = MDIconSize.medium,
            caption,
            style = ButtonStyle.Raised,
            size = ButtonSize.Default,
            intent = MDIntent.Default,
            isDisabled,
            relativeIcon = false
        } = this.props;
        const {styles} = this.state;
        const cx = classnames.bind(styles);

        const isIconElement = icon && typeof icon !== 'string';

        const hasCaptionAndIcon:boolean = !!caption && !!icon;

        return <button id={id}
                       type="button"
                       className={cx('button',
                           className,
                           style,
                           size,
                           intent,
                           {isDisabled},
                       )}
                       onClick={this._onClick}
                       onMouseDown={this._onMouseDown}
                       onMouseUp={this._onMouseUp}
                       onDoubleClick={this._onDblClick}
                       disabled={isDisabled}
        >
            <span className={cx('space', {relativeIcon, hasCaptionAndIcon})}>
            {icon
                ? (!isIconElement
                    ? <MDIcon name={icon as string} size={iconSize} className={cx('icon', iconClassName)} />
                    : icon)
                : null}
            </span>
            {caption ? <span className={cx('caption', captionClassName)}>{caption}</span> : null}
            {relativeIcon && <span className={cx('space', {relativeIcon, hasCaptionAndIcon})}></span>}
        </button>;
    }
}
